import { Badge } from '@/components/ui/badge';
import { ReleaseNotePlatform, PLATFORM_LABELS } from '../types';
import { cn } from '@/lib/utils';

const PLATFORM_STYLES: Record<ReleaseNotePlatform, string> = {
  [ReleaseNotePlatform.All]: 'bg-muted text-muted-foreground border-border',
  [ReleaseNotePlatform.Web]: 'bg-info/10 text-info border-info/30',
  [ReleaseNotePlatform.Mobile]:
    'bg-purple-500/10 text-purple-700 dark:text-purple-300 border-purple-500/30',
  [ReleaseNotePlatform.Api]: 'bg-warning/10 text-warning border-warning/30',
};

interface PlatformBadgeProps {
  platform: ReleaseNotePlatform;
}

export function PlatformBadge({ platform }: PlatformBadgeProps) {
  if (platform === ReleaseNotePlatform.All) return null;

  return (
    <Badge
      variant="outline"
      className={cn('text-xs font-medium', PLATFORM_STYLES[platform])}
    >
      {PLATFORM_LABELS[platform]}
    </Badge>
  );
}
